var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRemainingSessionsIcon = function SvgRemainingSessionsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.864 0C5.792 0 0.875 4.928 0.875 11C0.875 17.072 5.792 22 11.864 22C17.947 22 22.875 17.072 22.875 11C22.875 4.928 17.947 0 11.864 0ZM11.875 19.8C7.013 19.8 3.075 15.862 3.075 11C3.075 6.138 7.013 2.2 11.875 2.2C16.737 2.2 20.675 6.138 20.675 11C20.675 15.862 16.737 19.8 11.875 19.8ZM12.425 5.5H10.775V12.1L16.55 15.565L17.375 14.212L12.425 11.275V5.5Z",
    fill: "#B0B0B0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRemainingSessionsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "remaining-sessions-icon.e6c8f8fa04fe9353addbbe5f332334e8.svg";